import React from 'react';
import PropTypes from 'prop-types';
import {Status} from '@fiverr/fit';
import '@fiverr/globals';
import './style.scss';

const Badge = ({ type }) => {
    let badge,
        leftAlign;

    switch (type) {
        case 'featured':
            badge = (
                <Status classes="featured badge-hint js-badge-hint"
                    data-hint={i18n.t('gigs.featured.tooltip')}>
                    {i18n.t('general.featured')}
                </Status>
            );
            break;
        case 'choice':
            badge = <Status classes="quality-choice">{i18n.t('general.fiverrs_choice')}</Status>;
            break;
        case 'now':
            badge = (
                <span className="gig-badges available-now">
                    <span className="available-now-tooltip badge-hint js-badge-hint"
                        data-hint={i18n.t('gigs.available_now.tooltip')}>
                        {i18n.t('general.available_now')}
                    </span>
                </span>
            );
            break;
        case 'pro':
            badge = (
                <span className="pro-badge card-badge outline badge-hint js-badge-hint"
                    data-hint={i18n.t('gigs.pro.gig_card_tooltip_seller')}>
                    {i18n.t('general.pro')}
                </span>
            );
            break;
        case 'limited':
            leftAlign = true;
            badge = (
                <Status classes="limited-edition badge-hint js-badge-hint"
                    data-hint={i18n.t('gigs.limited_edition.tooltip')}>
                    {i18n.t('general.limited_edition')}
                </Status>
            );
            break;
        case 'talent':
            leftAlign = true;
            badge = (
                <Status classes="rising-talent badge-hint js-badge-hint"
                    data-hint={i18n.t('gigs.rising_talent.tooltip')}>
                    {i18n.t('gigs.rising_talent.text')}
                </Status>
            );
            break;
        default:
            break;
    }

    const classes = ['gig-badge'];
    leftAlign && classes.push('left');

    return <span className={classes.join(' ')}>{badge}</span>;
};

Badge.propTypes = {
    type: PropTypes.string
};

export default Badge;



// WEBPACK FOOTER //
// ./src/shared/badge/index.js